import { NotificationService } from 'src/app/core/common-services/notification.service';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { hasError } from 'src/app/core/base/base';
import { UserMenuService } from 'src/app/core/common-services/user-menu.service';
import { LoginResultDto, UserService } from 'src/app/core/common-services/user.services';
import { AdminGenerateUserOTPInputDto, AdminOTPInputDto, OTPPurpose, SetFundManagerPasswordInputDto } from 'src/app/core/data-models/authentication.data.models';
import { AuthenticationService } from 'src/app/core/data-services/authentication.service';
import { UserPermissionDataService } from 'src/app/core/data-services/user-permission/user-permission-data.service';
import { environment } from 'src/environments/environment';
import { EUserType } from 'src/app/shared/shared-data-models';
import { AppConfigService } from 'src/app/core/config/app-config.service';

@Component({
  selector: 'app-fund-manager-enter-otp',
  templateUrl: './fund-manager-enter-otp.component.html',
  styleUrls: ['./fund-manager-enter-otp.component.css']
})
export class FundManagerEnterOtpComponent implements OnInit, OnDestroy {
  @Input()email!:string;
  @Input()password!:string;
  @Input()confirmPassword!:string;
  @ViewChild('digitOne') digitOne!: ElementRef;
  @ViewChild('digitTwo') digitTwo!: ElementRef;
  @ViewChild('digitThree') digitThree!: ElementRef;
  @ViewChild('digitFour') digitFour!: ElementRef;
  // @ViewChild('digitFive') digitFive!: ElementRef;

  hasError = hasError;
  enterOTPForm!: FormGroup;

  minutes: number = 1;
  seconds: number = 0;
  intervalId: any;

  constructor(
    private router: Router,
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private notificationService:NotificationService,
    public appConfigService: AppConfigService
    ){
  }

  ngOnInit() {
    this.enterOTPForm = new FormGroup({
      otp1: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp2: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp3: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      otp4: new FormControl('', [Validators.required,Validators.maxLength(1)]),
      // otp5: new FormControl('', [Validators.required,Validators.maxLength(1)]),
    });


    this.intervalId = setInterval(() => {
      this.tick();
    }, 1000);

    this.generateUserOTP();
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  generateUserOTP(){
    this.minutes = 1;
    this.seconds = 0;
    clearInterval(this.intervalId);

    this.intervalId = setInterval(() => {
      this.tick();
    }, 1000);
    
    let dto: AdminGenerateUserOTPInputDto = {
      email:this.email,
      purpose: OTPPurpose.Registration,
      userTypeId:EUserType.FundManager,
    }
    this.authenticationService.generateUserOTP(  dto).subscribe(res => {
      if(res.success==true){
        if (environment.production == false) {
          this.authenticationService.getUserOTPDev(this.email || '',EUserType.FundManager).subscribe(res =>{
            if (res.success == true) {
              this.notificationService.success('OTP: '+res.resource?.otp!)
            }
          })
        }
      }
    else{
    }
    },
      (error) => {
        
      });
  }

  focusElement(digit: any) {
    if (digit !== undefined) {
      digit.select()
    }
  }
  verifyOTP() {
    var code = this.enterOTPForm.get('otp1')?.value.toString() +
      this.enterOTPForm.get('otp2')?.value.toString() +
      this.enterOTPForm.get('otp3')?.value.toString() +
      this.enterOTPForm.get('otp4')?.value.toString() 
      // this.enterOTPForm.get('otp5')?.value.toString() 

    if (!this.enterOTPForm.valid) {
      alert("Please Enter Valid otp");
      return;
    }
    
    let dto: SetFundManagerPasswordInputDto = {
      email: this.email,
      password:this.password,
      confirmPassword:this.confirmPassword,
      otp: code
    }
    this.authenticationService.setFundManagerPassword(  dto).subscribe(res => {
      if(res.success==true&&res.resource){   
        this.notificationService.success('Password has ben set sucessfully!')    
        this.router.navigate(['/authentication/login']);
      }
     else{
      this.notificationService.error(res.message!)    

     }
    },
      (error) => { 
        this.notificationService.error('Something went wrong!')    
      });
  }

  keytab1(event: any, len: any) {
    if (this.enterOTPForm.get('otp1')?.value.toString() !== '') {
      document.getElementById("otp2")!.focus();
    }
  }
  keytab2(event: any, len: any) {
    if (this.enterOTPForm.get('otp2')?.value.toString() !== '') {
      document.getElementById("otp3")!.focus();
    }else{
      document.getElementById("otp1")!.focus();
    }
  }
  keytab3(event: any, len: any) {
    if (this.enterOTPForm.get('otp3')?.value.toString() !== '') {
      document.getElementById("otp4")!.focus();
    }else{
      document.getElementById("otp2")!.focus();
    }
  }
  // keytab4(event: any, len: any) {
  //   if (this.enterOTPForm.get('otp4')?.value.toString() !== '') {
  //     document.getElementById("otp5")!.focus();
  //   }else{
  //     document.getElementById("otp3")!.focus();
  //   }
  // }
  // keytab5(event: any, len: any) {
  //   if (this.enterOTPForm.get('otp5')?.value.toString() !== '') {
  //     document.getElementById("otp6")!.focus();
  //   }else{
  //     document.getElementById("otp4")!.focus();
  //   }
  // }

  private tick() {
    if (this.seconds === 0) {
      if (this.minutes === 0) {
        clearInterval(this.intervalId);
        // Here you can perform any action when the timer reaches 0
      } else {
        this.minutes--;
        this.seconds = 59;
      }
    } else {
      this.seconds--;
    }
  }
 
}
